import axios, { type AxiosResponse, type InternalAxiosRequestConfig } from 'axios';
import { AuthService } from './AuthService';

axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
	if (config.url && config.url.indexOf('token') > 0) {
		return config;
	}

	if (AuthService.bearerToken) {
		config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${AuthService.bearerToken()}`;
		return config;
	}

	return config;
});

axios.interceptors.response.use(
	(response: AxiosResponse) => response,
	async err => {
		const error = err.response;

		if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
			try {
				await AuthService.refreshTokens();
				error.config.__isRetryRequest = true;
				error.config.headers = {
					...error.config.headers,
					Authorization: `Bearer ${AuthService.bearerToken()}`,
				};
				return axios(error.config);
			} catch (e) {
				return Promise.reject(e);
			}
		}
		return Promise.reject(error);
	}
);
